export default Object.freeze({
  STEPS: [
    {
      target: '#v-step-0',
      content: 'この画面ではトップメニューに表示されるお知らせの登録・編集ができます。<br>' +
                '<br>' +
                '・スローガン：ログイン後の画面の最上部に表示されます。<br>' +
                '　　　　　　　目標や方針など自由に使用してください<br>' +
                '・社内向け：利用者に通知したい際に利用してください。<br>',
      params: {
        enableScrolling: false,
        placement: 'bottom'
      }
    }
  ]
})
